import * as Sentry from "@sentry/react";

/**
 * Deployment identity for telemetry, derived from the hostname. Mirrors the
 * server's APP_ENV mapping (server/config.ts) so client and server events
 * share the same Sentry environment names.
 */
function resolveEnvironment(): "production" | "staging" | "dev" | "local" {
  const hostname = window.location.hostname;
  if (hostname === "www.onsemble.pro") return "production";
  if (hostname === "staging.onsemble.pro") return "staging";
  if (hostname === "dev.onsemble.pro") return "dev";
  return "local";
}

const dsn = import.meta.env.VITE_CLIENT_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: resolveEnvironment(),
    sendDefaultPii: true,
  });
}
